export enum ArrowEnum {
  arrow = 'arrow',
}

export enum OrientationEnum {
  horizontal = 'horizontal',
  vertical = 'vertical',
}
